<template>
 <el-col style="padding: 5px">
      <el-card>
        <div slot="header">
          <div>
            <span v-if="trip.route">{{ trip.route.description }} </span>
            <span v-else>Route not selected...</span>
            <div style="margin: 5px 0"><strong>{{ trip.dep_date | cleanDate }}</strong></div>
            <span><el-button @click="handleUpdateTripSummary" size="small" type="warning">UPDATE</el-button></span>
            <el-button @click="handlePrintReport(trip)" type="success" size="small">Print Report</el-button>
          </div>
        </div>

        <div>
          <div style="padding: 0px 20px 20px;">
            <el-steps
              process-status="wait"
              finish-status="success"
              style="height: 80px;"
              direction="vertical"
              :active="1">
              <el-step :title="trip.route.from_loc.name"></el-step>
              <el-step :title="trip.route.to_loc.name"> {{ trip.route.to_loc.name}}</el-step>
            </el-steps>
          </div>

          <div>
              <div style="display: flex;padding: 10px; align-items: center">
              <div>
                <img src="../../assets/user.svg" height="40px" alt="">
                <span> Driver's Name: <strong>{{ trip.driver.first_name  }} </strong> </span>
              </div>
            </div>
          </div>
        </div>
      </el-card>
    </el-col>
</template>

<script>
import { putTrip } from '@/services/trip'
import { downloadReport } from '@/services/reports'

export default{
  name: 'TripItem',
  props: ['trip'],

  methods: {
    handlePrintReport (trip) {
      const downloadUrl = `from_date=${trip.dep_date}&trip_id=${trip.id}&report_type=by_trip&is_date_range=False`
      downloadReport(downloadUrl)
    },

    handleUpdateTripSummary () {
      this.$router.push({ name: 'TripManifestUpdate', params: { id: this.trip.id } })
    },

    handleStartStopTrip () {
      const modelInfo = { ...this.trip }
      modelInfo.dep_date = new Date().toJSON()
      modelInfo.route = modelInfo.route.id
      putTrip(modelInfo)
        .then(res => {
          this.$message(`Trip started successfully at ${modelInfo.dep_date}`)
        })
        .catch(() => {
          this.$message.error('Error starting trip, contact admin')
        })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/trips/TripItem.vue